import male from '../assets/icons/male.png';
import female from '../assets/icons/female.png';
import neutral from '../assets/icons/user.png';

/**
 * Avatar for a staff member — the same three icons the ManagerApp uses, so a person looks the
 * same on both surfaces. Staff rows carry no gender yet, so everyone renders male for now.
 */
export type PersonGender = 'male' | 'female' | null | undefined;

export const avatarFor = (gender?: PersonGender): string => {
    if (gender === 'female') return female;
    if (gender === 'male') return male;
    // Switch to `neutral` once staff records carry a gender.
    return male;
};
